/** @jsx isolateComponent */

import { Dropdown } from '@zapier/design-system-revenue/src/components/other/Dropdown';
import { TaskLimitDropdownSubstitute } from '@zapier/design-system-revenue/src/components/pricing-pages/PricingPageV3/TaskLimitDropdownSubstitute';
import { Currency, PlanV2 } from '@zapier/design-system-revenue/src/types';
import { isolateComponent } from '@zapier/common-utils';

import { TaskLimitDropdownListItem } from './TaskLimitDropdownListItem';

type TaskLimitDropdownProps = {
  /** The type of currency to display. */
  currency: Currency;
  /** The function that runs when the PlanActionButton is clicked. */
  onSelect: (plan: PlanV2) => void;
  /** The options to choose from in the dropdown */
  options: PlanV2[];
  /** The currently selected plan */
  selectedPlan: PlanV2;
};

const getSelectedItem = (plan: PlanV2): string =>
  `${Number(plan.tasks).toLocaleString()} Tasks /mo`;

/**
 * A component that renders a dropdown with task limit details.
 */
export const TaskLimitDropdown = ({
  currency,
  onSelect,
  options,
  selectedPlan,
}: TaskLimitDropdownProps) => {
  return options.length > 1 ? (
    <Dropdown
      ariaLabel="Task Limit"
      getLabelForListItems={(item: PlanV2) => (
        <TaskLimitDropdownListItem currency={currency} plan={item} />
      )}
      getLabelForSelectedItem={(item: PlanV2) => getSelectedItem(item)}
      initialSelectedItem={selectedPlan}
      items={options}
      menuAriaLabel="List of available task limits"
      onChange={onSelect}
      placeholder="Choose a task limit..."
    />
  ) : (
    <TaskLimitDropdownSubstitute text={getSelectedItem(selectedPlan)} />
  );
};
